module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rick Bass\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("RICK BASS’s fiction has received O. Henry Awards, numerous Pushcart Prizes, awards from the Texas Institute of Letters, fellowships from the National Endowment for the Arts and the Guggenheim Foundation, and his memoir, "), _c('I', [_vm._v("Why I Came West,")]), _vm._v(" was a finalist for a National Book Critics Circle Award.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yjdDSe/tc-custom/9780547349350.jpg?1718183455699",
      "alt": "This image is the cover for the book Book of Yaak"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Book of Yaak\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Yaak Valley of northwestern Montana is one of the last great wild places in the United States, a land of black bears and grizzlies, wolves and coyotes, bald and golden eagles, wolverine, lynx, marten, fisher, elk, and even a handful of humans. It is a land of magic, but its magic may not be enough to save it from the forces threatening it now. The Yaak does have one trick up its sleeve, though: a writer to give it voice. In Winter Rick Bass portrayed the wonder of living in the valley. In The Book of Yaak he captures the soul of the valley itself, and he shows how, if places like the Yaak are lost, we too are lost. Rick Bass has never been a writer to hold back, but The Book of Yaak is his most passionate book yet, a dramatic narrative of a man fighting to defend the place he loves.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0